import axios from "axios";

import API_URL from "..";
import { API } from "../client";

const API_URL_BOOKING = API_URL + "booking/";

const createBooking = async (token, booking) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.post(API_URL_BOOKING + "/", booking, config);

  return res.data;
};

const updateBooking = async (token, booking) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.put(API_URL_BOOKING + "/", booking, config);

  return res.data;
};

const updateWallet = async (token, booking) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.put(API_URL_BOOKING + "/wallet", booking, config);

  return res.data;
};

const getBooking = async (token, id) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await API.get(API_URL_BOOKING + `/${id}`, config);

  return res.data;
};

const getBookingById = async (token, id) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await API.get(API_URL_BOOKING + `/booking/${id}`, config);

  return res.data;
};

const getBookings = async (token, query) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await API.get(
    API_URL_BOOKING +
      `?startDate=${query.startDate}&endDate=${query.endDate}&page=${query.page}&status=${query.status}&search=${query.search}&state=${query.state}&payment=${query.payment}&limit=${query.limit}&channel=${query.channel}&company=${query.company}&carrier=${query.carrier}`,
    config
  );

  return res.data;
};

const getBookingsByCompany = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await API.get(API_URL_BOOKING + "/company", config);

  return res.data;
};

const getCompanyBookings = async (token, query) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await API.get(
    API_URL_BOOKING +
      `/company-booking?startDate=${query.startDate}&endDate=${query.endDate}&page=${query.page}&status=${query.status}&search=${query.search}&state=${query.state}&payment=${query.payment}&limit=${query.limit}`,
    config
  );

  return res.data;
};

const getBookingByUser = async (token, query) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await API.get(
    API_URL_BOOKING +
      `/user?startDate=${query.startDate}&endDate=${query.endDate}&page=${query.page}&status=${query.status}&search=${query.search}&state=${query.state}&payment=${query.payment}&limit=${query.limit}`,
    config
  );

  return res.data;
};

const updateBookingRequestStatus = async (token, data) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.put(
    API_URL_BOOKING + `/request-status/${data.id}`,
    data,
    config
  );

  return res.data;
};

const getHalfRefund = async (token, searchTerm, status, startDate, endDate) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.get(
    API_URL_BOOKING +
      `/half-refund?PNR=${searchTerm}&status=${status}&startDate=${startDate}&endDate=${endDate}`,
    config
  );

  return res.data;
};

const updateHalfRefundStatus = async (token, bookingId, newStatus) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token} `,
    },
  };

  const res = await axios.put(
    API_URL_BOOKING + `/half-refund/${bookingId}`,
    { status: newStatus },
    config
  );

  return res.data;
};

const refundHalfBooking = async (token, bookingId) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const res = await axios.post(
    API_URL_BOOKING + `/half-refund/${bookingId}`,
    {},
    config
  );

  return res.data;
};

const extractPassport = async (file) => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  const data = new FormData();
  data.append("file", file);
  const res = await axios.post(
    API_URL + `/labour/employee/extract-passport`,
    data,
    config
  );

  return res.data;
};

const apiBooking = {
  createBooking,
  getBooking,
  getBookings,
  updateWallet,
  updateBooking,
  getCompanyBookings,
  getBookingsByCompany,
  getBookingById,
  getBookingByUser,
  updateBookingRequestStatus,
  getHalfRefund,
  updateHalfRefundStatus,
  refundHalfBooking,
  extractPassport,
};

export default apiBooking;
